import { Component, input, signal, OnDestroy, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-inline-moving-text',
  imports: [],
  templateUrl: './inline-moving-text.html',
  styleUrl: './inline-moving-text.css',
})
export class InlineMovingText implements OnInit, OnDestroy {
  // Input properties
  words = input.required<string[]>();
  interval = input<number>(4000); // Default 3 seconds
  staticWord = input<string>(''); // Static word to show before the moving word
  movingWordClass = input<string>(''); // Custom class for the moving word

  // Internal state
  currentIndex = signal(0);
  isAnimating = signal(false);

  // Computed values
  currentWord = signal('');

  private intervalId?: ReturnType<typeof setInterval>;
  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeComponent();
    }
  }

  private initializeComponent(): void {
    const wordsArray = this.words();
    if (wordsArray.length > 0) {
      this.currentWord.set(wordsArray[0]);
      this.startAnimation();
    }
  }

  private startAnimation(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const wordsArray = this.words();
    if (wordsArray.length <= 1) return;

    // Clear any existing interval
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.cycleToNextWord();
    }, this.interval());
  }

  private cycleToNextWord(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    const wordsArray = this.words();
    if (wordsArray.length <= 1) return;

    this.isAnimating.set(true);

    // Change word after animation starts
    setTimeout(() => {
      const currentIdx = this.currentIndex();
      const nextIdx = (currentIdx + 1) % wordsArray.length;
      this.currentIndex.set(nextIdx);
      this.currentWord.set(wordsArray[nextIdx]);
    }, 150); // Half of the CSS animation duration (300ms)

    // Reset animation state after animation completes
    setTimeout(() => {
      this.isAnimating.set(false);
    }, 300); // Full CSS animation duration
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId) && this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
